import './GlowSubWidgets.css';
import React, {useState} from "react";
import MorningCheckIn from './transitionWidgets/MorningCheckIn.js';
import Routine from './transitionWidgets/Routine.js';
import EveningCheckIn from './transitionWidgets/EveningCheckIn.js';
import StartingWork from './transitionWidgets/StartingWork.js';
import StoppingWork from './transitionWidgets/StoppingWork.js';
import FocusHelp from './transitionWidgets/FocusHelp.js';

function TransitionBlock(props) {
    const [transitionType, setTransitionType] = useState(props.subtype)

    const prepMap = {
        "morningRoutine": <Routine routine={props.userProfile.morningRoutineSteps}/>,
        "morningCheckIn": <MorningCheckIn/>,
        "eveningRoutine": <Routine routine={props.userProfile.eveningRoutineSteps}/>,
        "eveningCheckIn": <EveningCheckIn/>,
        "startingWork": <StartingWork/>,
        "stoppingWork": <StoppingWork/>,
        "focusHelp": <FocusHelp/>
    }

    return (
        <div>
            {transitionType === "unspecified" &&
            <div>
                <p className="glowHeaderText"> transitions </p>
                <div className="row center overflow transitionOptionsDiv">
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("morningRoutine")}> morning routine</p>
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("morningCheckIn")}> morning check in</p>
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("eveningRoutine")}> evening routine</p>
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("eveningCheckIn")}> evening check in</p>
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("startingWork")}> starting work</p>
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("stoppingWork")}> stopping work</p>
                    <p className="glowBlockSelectOptions" onClick={() => setTransitionType("focusHelp")}> get focused</p>
                </div>
                </div>
            }
            {transitionType !== "unspecified" &&
                <div>
                    {prepMap[transitionType]}
                </div>
            }
        </div>
    )
}

export default TransitionBlock;